import './user-display.css';
import angular from 'angular';
import UserDisplayComponent from './user-display.component';
import userPopup from '../../ttb-core/components/popups/user-popup'


const userDisplay = angular.module('ttb.widgets.userDisplay', [
    userPopup
])
    .component('userDisplay', UserDisplayComponent)
    .name;

export default userDisplay;


// WEBPACK FOOTER //
// ../widgets/user-display/index.js